import { schema } from 'normalizr';

const entitySchema = new schema.Entity('category', undefined, { idAttribute: 'id' });

entitySchema.define({
  children: [entitySchema]
});

export default entitySchema;